import { useQuery } from "@tanstack/react-query";

import { listSoilSightProjects } from "services";

import { useIsAuthenticated } from "utils";

import { LIST_SOIL_SIGHT_PROJECTS } from "consts";

import { SoilSightProject } from "models";

export const useListSoilSightProjects = (klimFarmId: string) => {
  const isAuthenticated = useIsAuthenticated();

  return useQuery<SoilSightProject[]>({
    queryKey: [LIST_SOIL_SIGHT_PROJECTS, klimFarmId],
    queryFn: () => listSoilSightProjects(klimFarmId),
    enabled: isAuthenticated && !!klimFarmId,
    staleTime: 30_000,
  });
};
